import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_3 = { class: "card-body p-xl-40" }
const _hoisted_4 = { class: "row g-3 align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_7 = { value: null }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "year-switcher" }
const _hoisted_10 = ["disabled", "aria-label"]
const _hoisted_11 = { value: "lifetime" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["disabled", "aria-label"]
const _hoisted_14 = { class: "col-lg-4" }
const _hoisted_15 = { class: "d-flex justify-content-lg-end" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_ProfitLoss = _resolveComponent("ProfitLoss")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: _ctx.pageTitle }, null, 8, ["pageTitle"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.warehouse_id) = $event)),
                  class: "form-select report-select h-55 shadow-none"
                }, [
                  _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.all_warehouses`)), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: warehouse.id,
                      value: warehouse.id
                    }, _toDisplayString(warehouse.name), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.warehouse_id]
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light h-55 px-3",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeYear(-1))),
                    disabled: _ctx.filters.year === 'lifetime',
                    "aria-label": _ctx.$t(`${_ctx.i18nScope}.previous_year`)
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "ri-arrow-left-s-line" }, null, -1)
                  ]))], 8, _hoisted_10),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.year) = $event)),
                    class: "form-select report-select h-55 shadow-none"
                  }, [
                    _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.lifetime`)), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: year,
                        value: year
                      }, _toDisplayString(year), 9, _hoisted_12))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.year]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light h-55 px-3",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeYear(1))),
                    disabled: _ctx.filters.year === 'lifetime' || Number(_ctx.filters.year) >= _ctx.currentYear,
                    "aria-label": _ctx.$t(`${_ctx.i18nScope}.next_year`)
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1)
                  ]))], 8, _hoisted_13)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-three d-inline-flex align-items-center h-55 px-4",
                  disabled: _ctx.exporting,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportProfitLoss && _ctx.exportProfitLoss(...args)))
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-file-excel-2-line me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.exporting ? _ctx.$t(`${_ctx.i18nScope}.exporting`) : _ctx.$t(`${_ctx.i18nScope}.excel`)), 1)
                ], 8, _hoisted_16)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ProfitLoss, {
        rows: _ctx.rows,
        loading: _ctx.loading,
        summary: _ctx.summary,
        "includes-income": _ctx.includesIncome,
        "i18n-scope": _ctx.i18nScope
      }, null, 8, ["rows", "loading", "summary", "includes-income", "i18n-scope"]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}